import React from 'react';
import { BarChart, Bar, XAxis, YAxis, ZAxis, CartesianGrid, Tooltip, Legend, Label, ResponsiveContainer } from 'recharts';
import green from '@material-ui/core/colors/green';

export default function Chart(data) {
  return (
    <React.Fragment>
      <ResponsiveContainer height="100%">
        <BarChart
          height={500}
          width={800}
          data={data.data.Chart}
          margin={{
            top: 20,
            right: 5,
            bottom: 30,
            left: 5,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />

          <XAxis dataKey="Date"/>
          <YAxis/>
          <Tooltip/>
          <Bar dataKey="Total" barSize={30} fill={green[400]} unit="kg"/>

        </BarChart>
      </ResponsiveContainer>
    </React.Fragment>
  );
}
